var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(-4 20) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 16,
    height: 16,
    transform: "translate(4 4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M5.006.759,4.243,0,0,4.247,4.247,8.494l.759-.759L1.519,4.247Z",
    transform: "translate(14.641 16.247) rotate(180)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.a02087436fdf8be5c849f11688a8db1c.svg";
export { ForwardRef as ReactComponent };